import type { AICustomerProfile } from '../types/contracts';
import { CHANNEL_ICON } from '../lib/format';
import { JourneyPipeline } from './LeadStage';

export function CustomerIntelligencePanel({ profile }: { profile: AICustomerProfile }) {
  return (
    <aside className="space-y-4">
      <div className="rounded-2xl bg-white border border-gray-100 p-5">
        <h3 className="text-[10px] font-black tracking-widest text-gray-400 mb-3">العميل</h3>
        <p className="text-sm font-bold text-gray-900">{profile.name}</p>
        <p className="text-xs text-gray-500">{profile.business}</p>
        <div className="mt-2 space-y-1 text-xs text-gray-600">
          <p className="flex items-center gap-1.5"><i className={CHANNEL_ICON[profile.channel]} /> {profile.channel}</p>
          <p className="flex items-center gap-1.5"><i className="ri-map-pin-line" /> {profile.location}</p>
        </div>
        <div className="mt-3 flex items-center justify-between rounded-xl bg-gray-50 px-3 py-2">
          <span className="text-[11px] font-semibold text-gray-500">عميل محتمل</span>
          <span className={`text-[11px] font-black ${profile.temperature === 'hot' ? 'text-rose-600' : profile.temperature === 'warm' ? 'text-amber-600' : 'text-sky-600'}`}>
            {profile.temperature === 'hot' ? 'ساخن 🔥' : profile.temperature === 'warm' ? 'دافئ' : 'بارد'} · {profile.score}
          </span>
        </div>
      </div>

      <div className="rounded-2xl bg-white border border-gray-100 p-5">
        <h3 className="text-[10px] font-black tracking-widest text-gray-400 mb-3">رحلة العميل</h3>
        <JourneyPipeline journey={profile.journey} />
      </div>

      <div className="rounded-2xl bg-white border border-gray-100 p-5">
        <h3 className="text-[10px] font-black tracking-widest text-gray-400 mb-3">البيانات التجارية</h3>
        <dl className="space-y-1.5 text-xs">
          <div className="flex justify-between"><dt className="text-gray-500">الباقة الحالية</dt><dd className="font-bold text-gray-800">{profile.commercial.current_plan}</dd></div>
          <div className="flex justify-between"><dt className="text-gray-500">انتهاء التجربة</dt><dd className="font-bold text-gray-800">{profile.commercial.demo_expires_in_days != null ? `${profile.commercial.demo_expires_in_days} يوم` : '—'}</dd></div>
          <div className="flex justify-between"><dt className="text-gray-500">آخر نشاط</dt><dd className="font-bold text-gray-800">{profile.commercial.last_activity}</dd></div>
          <div className="flex justify-between"><dt className="text-gray-500">الفواتير</dt><dd className="font-bold text-gray-800">{profile.commercial.invoices_count || '—'}</dd></div>
          <div className="flex justify-between"><dt className="text-gray-500">الفروع</dt><dd className="font-bold text-gray-800">{profile.commercial.branches}</dd></div>
        </dl>
      </div>

      <div className="rounded-2xl bg-white border border-gray-100 p-5">
        <h3 className="text-[10px] font-black tracking-widest text-gray-400 mb-3">ملاحظات المساعد</h3>
        <div className="space-y-3 text-xs">
          <div>
            <p className="font-bold text-gray-700 mb-1">مهتم بـ:</p>
            <ul className="list-disc list-inside text-gray-600 space-y-0.5">
              {profile.ai_notes.interested_in.map((x) => <li key={x}>{x}</li>)}
            </ul>
          </div>
          <div>
            <p className="font-bold text-gray-700 mb-1">الاعتراضات:</p>
            {profile.ai_notes.objections.length ? (
              <ul className="list-disc list-inside text-gray-600 space-y-0.5">
                {profile.ai_notes.objections.map((x) => <li key={x}>{x}</li>)}
              </ul>
            ) : <p className="text-gray-400">—</p>}
          </div>
          <div className="rounded-xl bg-teal-50 border border-teal-100 px-3 py-2">
            <p className="text-[10px] font-black text-teal-700 tracking-wide">أفضل إجراء تالٍ</p>
            <p className="font-bold text-teal-900 mt-0.5">{profile.ai_notes.next_best_action}</p>
          </div>
        </div>
      </div>
    </aside>
  );
}
